import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const timeCorrectionPath = '/settings/time-correction'
export const timeCorrectionEditPath = `/settings/time-correction/edit/:employeeUUID(${UUIDPathRegex})`
export const auditTrailPath = '/settings/time-correction/audit-trail'
export const employeeAuditTrailPath = `/settings/time-correction/edit/:employeeUUID(${UUIDPathRegex})/audit-trail`
